// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationAfterLogin-root-Ip3mq {
	margin: 0;
}

.NavigationAfterLogin-navDropDown-VPG2P {
	border: 0px;
}

.NavigationAfterLogin-userAvatar-YVV53 {
	height: 30px;
	width: 30px;
	border-radius: 50%;
	border: 2px solid var(--primary-border);
}

.NavigationAfterLogin-breakPointScreen-VzO8z {
	display: none !important;
}

.NavigationAfterLogin-nonBreakPointScreen-AmKAJ {
	display: block !important;
}

.NavigationAfterLogin-menuDivider-cebAH {
	border-top: 1px solid var(--primary-border);
	padding-bottom: 20px;
}

.NavigationAfterLogin-centerMenu-nMAPn {
	position: absolute;
	left: 0;
	right: 0;
	text-align: center;
	top: 50%;
	max-width: 500px;
	margin: 0 auto;
	transform: translateY(-50%);
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
}

.NavigationAfterLogin-centerLink-wAtVO {
	display: inline-block;
	font-size: 18px;
	color: var(--white-text);
	margin-right: 50px;
	font-weight: 600;
}

.NavigationAfterLogin-centerLink-wAtVO a,
.NavigationAfterLogin-centerLink-wAtVO a:hover,
.NavigationAfterLogin-centerLink-wAtVO a:focus {
	color: var(--white-text);
	text-decoration: none;
}

.NavigationAfterLogin-dot-uzlvT {
	position: relative;
}

.NavigationAfterLogin-dot-uzlvT::after {
	content: '';
	width: 6px;
	height: 6px;
	background: var(--primary-white-bg);
	border-radius: 50%;
	position: absolute;
	top: 48%;
	right: -26px;
}

.NavigationAfterLogin-dot-uzlvT::before {
	content: '';
	width: 57px;
	height: 1.5px;
	background: var(--primary-white-bg);
	position: absolute;
	bottom: -3px;
	right: 0;
	left: 0;
	margin: 0 auto;
}

.NavigationAfterLogin-menuDividerMobile-GOaSD {
	border-top: 1px solid var(--primary-border);

}

.NavigationAfterLogin-listCarCss-xHMP6 {
	font-weight: 500;
	padding-top: 19px !important;
}

.NavigationAfterLogin-listCarCss-xHMP6 a {
	font-size: 18px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 165px;
	text-align: right;

}

@media screen and (max-width: 1200px) {
	.NavigationAfterLogin-breakPointScreen-VzO8z {
		display: block !important;
	}

	.NavigationAfterLogin-nonBreakPointScreen-AmKAJ {
		display: none !important;
	}
}

@media(max-width:1200px) {

	.NavigationAfterLogin-newMenu-q1bcX {
		height: 100vh;
		background: var(--primary-white-bg) !important;
		overflow-y: scroll;
	}

}

@media(min-width:768px) and (max-width:1200px) {
	.NavigationAfterLogin-newMenu-q1bcX {
		left: 0;
	}
}

@media (min-width: 1201px) {
	.NavigationAfterLogin-menuFlexContainer-oINOE {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-ms-flex-wrap: nowrap;
		    flex-wrap: nowrap;
	}

	.NavigationAfterLogin-menuFlexContainer-oINOE li {
		padding: 0 !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationAfterLogin/NavigationAfterLogin.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,kBAAkB;CAClB,QAAQ;CACR,gBAAgB;CAChB,cAAc;CACd,2BAA2B;CAC3B,mCAAmC;CACnC,gCAAgC;CAChC,+BAA+B;CAC/B,8BAA8B;AAC/B;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;;CAGC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,mCAAmC;CACnC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,OAAO;CACP,cAAc;AACf;;AAEA;CACC,2CAA2C;;AAE5C;;AAEA;CACC,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,YAAY;CACZ,iBAAiB;;AAElB;;AAEA;CACC;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;;CAEC;EACC,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;CACnB;;AAED;;AAEA;CACC;EACC,OAAO;CACR;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAiB;MAAjB,iBAAiB;CAClB;;CAEA;EACC,qBAAqB;CACtB;AACD","sourcesContent":[".root {\n\tmargin: 0;\n}\n\n.navDropDown {\n\tborder: 0px;\n}\n\n.userAvatar {\n\theight: 30px;\n\twidth: 30px;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-border);\n}\n\n.breakPointScreen {\n\tdisplay: none !important;\n}\n\n.nonBreakPointScreen {\n\tdisplay: block !important;\n}\n\n.menuDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tpadding-bottom: 20px;\n}\n\n.centerMenu {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttext-align: center;\n\ttop: 50%;\n\tmax-width: 500px;\n\tmargin: 0 auto;\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n\t-moz-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\t-o-transform: translateY(-50%);\n}\n\n.centerLink {\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tcolor: var(--white-text);\n\tmargin-right: 50px;\n\tfont-weight: 600;\n}\n\n.centerLink a,\n.centerLink a:hover,\n.centerLink a:focus {\n\tcolor: var(--white-text);\n\ttext-decoration: none;\n}\n\n.dot {\n\tposition: relative;\n}\n\n.dot::after {\n\tcontent: '';\n\twidth: 6px;\n\theight: 6px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 50%;\n\tposition: absolute;\n\ttop: 48%;\n\tright: -26px;\n}\n\n.dot::before {\n\tcontent: '';\n\twidth: 57px;\n\theight: 1.5px;\n\tbackground: var(--primary-white-bg);\n\tposition: absolute;\n\tbottom: -3px;\n\tright: 0;\n\tleft: 0;\n\tmargin: 0 auto;\n}\n\n.menuDividerMobile {\n\tborder-top: 1px solid var(--primary-border);\n\n}\n\n.listCarCss {\n\tfont-weight: 500;\n\tpadding-top: 19px !important;\n}\n\n.listCarCss a {\n\tfont-size: 18px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twidth: 165px;\n\ttext-align: right;\n\n}\n\n@media screen and (max-width: 1200px) {\n\t.breakPointScreen {\n\t\tdisplay: block !important;\n\t}\n\n\t.nonBreakPointScreen {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media(max-width:1200px) {\n\n\t.newMenu {\n\t\theight: 100vh;\n\t\tbackground: var(--primary-white-bg) !important;\n\t\toverflow-y: scroll;\n\t}\n\n}\n\n@media(min-width:768px) and (max-width:1200px) {\n\t.newMenu {\n\t\tleft: 0;\n\t}\n}\n\n@media (min-width: 1201px) {\n\t.menuFlexContainer {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tflex-wrap: nowrap;\n\t}\n\n\t.menuFlexContainer li {\n\t\tpadding: 0 !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NavigationAfterLogin-root-Ip3mq`,
	"navDropDown": `NavigationAfterLogin-navDropDown-VPG2P`,
	"userAvatar": `NavigationAfterLogin-userAvatar-YVV53`,
	"breakPointScreen": `NavigationAfterLogin-breakPointScreen-VzO8z`,
	"nonBreakPointScreen": `NavigationAfterLogin-nonBreakPointScreen-AmKAJ`,
	"menuDivider": `NavigationAfterLogin-menuDivider-cebAH`,
	"centerMenu": `NavigationAfterLogin-centerMenu-nMAPn`,
	"centerLink": `NavigationAfterLogin-centerLink-wAtVO`,
	"dot": `NavigationAfterLogin-dot-uzlvT`,
	"menuDividerMobile": `NavigationAfterLogin-menuDividerMobile-GOaSD`,
	"listCarCss": `NavigationAfterLogin-listCarCss-xHMP6`,
	"newMenu": `NavigationAfterLogin-newMenu-q1bcX`,
	"menuFlexContainer": `NavigationAfterLogin-menuFlexContainer-oINOE`
};
module.exports = ___CSS_LOADER_EXPORT___;
